import * as normalizr from 'normalizr'
import { records } from '@ims/1edtech-frontend-common'
import * as R from 'ramda'

export const TRUSTED_APPS_DETAILS_RECORD = 'trustedAppsDetails'

const trustedAppsDetails: records.modules.IModule = {
  record: TRUSTED_APPS_DETAILS_RECORD,
  schema: new normalizr.schema.Entity(
    TRUSTED_APPS_DETAILS_RECORD,
    {},
    {
      idAttribute: () => '1',
      processStrategy: R.assoc('id', 1),
    },
  ),
  api: {
    create: () => 'trustedapps/organizations/trustedapps/config',
    get: () => 'trustedapps/organizations/trustedapps/config',
    getList: () => 'trustedapps/organizations/trustedapps/config',
    update: () => 'trustedapps/organizations/trustedapps/config',
    prepareUpdateData: R.dissoc('id'),
    delete: () => 'trustedapps/organizations/trustedapps/config',
  },
}

export default trustedAppsDetails
